import { SilometrixThreshold } from '@old/features/administrator/silometrix-threshold/silometrix-threshold';

export function SilometrixThresholdPage() {
  return <SilometrixThreshold />;
}
